module.exports = __webpack_public_path__ + "static/media/backwards-icon.765732a5.svg";